import StockImages from '../lib/stock-images.js';

STUDIP.domReady(() => {
    StockImages.init();
});
